import jQuery from 'jquery';
let $ = jQuery;

/**
* class HSN.Template.ProductVideo
*
* Provides lightweight functionality for displaying videos
**/
HSN.Template.ProductVideo = function(config) {
    var scope = this;
    this.application = config.application,
    this.container = $(config.container) ? config.container : null;
    this.triggerElement = config.triggerElement;
    this.videoUrls = config.videoUrls;
    this.videoAnalytics = config.videoAnalytics;
    this.assetId = config.assetId;
    this.webpid = config.webpid ? config.webpid : null;
    this.backgroundColor = config.backgroundColor;
    this.videoPlayerInstance = null;
    this.Events = new HSN.EventCoordinator();
    this.videoObj = {};

    //play video without container
    if(!this.container) {
        this.PlayVideo();
        return false;
    }

    //events
    this.container.on('click', this.container.find(this.triggerElement), function () {
        scope.PlayVideo();
        return false;
    });
};

HSN.Template.ProductVideo.EVENT = {
    VIDEO_STOP: 'video:stop',
    AFTER_MODAL_OPEN: 'video:after_modal_open'
};

HSN.Template.ProductVideo.prototype = {
    Events: null,
    PlayVideo : function() {
        var enableCaptions = false;
        var captionUrl = "";

        //use getcaptions service if webpid is passed in:
        if(this.webpid && this.assetId) {
            enableCaptions = true;
            captionUrl = "https://" + location.host + "/services/getcaptions/" + this.webpid + "/" + this.assetId;
        }
        
        this.videoObj =
        { 
            media : {
                title: this.videoAnalytics.name,
                source :
                [
                    { src: this.videoUrls.httpUrl, type: 'video/mp4'}
                       
                ],
                track :
                [
                    { kind: 'captions', type: 'application/x-subrip', srclang: 'en', src: captionUrl }
                ]
            },
            autoplay : true,
           

            captioning :
            {
                enabled: enableCaptions
            }
        };

        this.videoObj.category = this.videoAnalytics.category;
        this.videoObj.name = this.videoAnalytics.name;
        this.videoObj.label = this.videoAnalytics.label;

        //display video in modal:        
        var vidModal = HSN.Instance().GetVideoModal();
        HSN.Instance().Events.Trigger(HSN.Template.ProductVideo.EVENT.AFTER_MODAL_OPEN,
            { videoObject: this, videoModal: vidModal });
        vidModal.Show(this.videoObj, 724, 408, true, true);
    },

    StopVideo: function() {
        this.GetVideoInstance().stop();
    },

    GetVideoInstance: function() {
        return this.videoPlayerInstance;
    },

    SetVideoInstance: function(instance) {
        this.videoPlayerInstance = instance;
    }
};




// WEBPACK FOOTER //
// ./assets/js/HSN/Template/ProductVideo.js